/**
 * Signal da je prva stranica stvarno na ekranu.
 *
 * Preloader je ranije čekao samo fontove i `window.load`. Stranice se učitavaju
 * lenjo, pa se dešavalo da se loader skloni pre nego što chunk stigne — ostane
 * prazna tamna stranica sa tankom trakom, ceo ekran crn sekundu-dve. Na
 * telefonu, gde je parsiranje sporije, to je bilo najgore.
 *
 * `markAppReady()` zove <RouteReady /> iz Suspense granice čim se sadržaj
 * montira; `appReady()` čeka na to.
 */

let settle;
const promise = new Promise((resolve) => { settle = resolve; });
let done = false;

/** Promise koji se razrešava kad je prva ruta montirana. */
export function appReady() {
  return promise;
}

/** Javlja da je sadržaj na ekranu. Višestruki poziv nema efekta. */
export function markAppReady() {
  if (done) return;
  done = true;
  settle();
}

/** Da li je već spremno — za slučaj da neko pita posle. */
export function isAppReady() {
  return done;
}
